export default "__VITE_ASSET__DIOgiB2r__"